"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSelect = void 0;
const components_1 = require("@apitable/components");
const core_1 = require("@apitable/core");
const icons_1 = require("@apitable/icons");
const react_1 = __importDefault(require("react"));
const FieldIconMap = {
    [core_1.FieldType.DeniedField]: icons_1.LockFilled,
    [core_1.FieldType.Text]: icons_1.LongtextOutlined,
    [core_1.FieldType.Number]: icons_1.NumberOutlined,
    [core_1.FieldType.SingleSelect]: icons_1.SelectSingleOutlined,
    [core_1.FieldType.MultiSelect]: icons_1.SelectMultipleOutlined,
    [core_1.FieldType.DateTime]: icons_1.CalendarOutlined,
    [core_1.FieldType.Attachment]: icons_1.AttachmentOutlined,
    [core_1.FieldType.Link]: icons_1.LinktableOutlined,
    [core_1.FieldType.URL]: icons_1.LinkOutlined,
    [core_1.FieldType.Email]: icons_1.EmailOutlined,
    [core_1.FieldType.Phone]: icons_1.TelephoneOutlined,
    [core_1.FieldType.Checkbox]: icons_1.CheckboxOutlined,
    [core_1.FieldType.Rating]: icons_1.StarOutlined,
    [core_1.FieldType.Member]: icons_1.UserOutlined,
    [core_1.FieldType.LookUp]: icons_1.LookupOutlined,
    [core_1.FieldType.Formula]: icons_1.FormulaOutlined,
    [core_1.FieldType.Currency]: icons_1.CurrencyUsdOutlined,
    [core_1.FieldType.Currency]: icons_1.CurrencyCnyOutlined,
    [core_1.FieldType.Percent]: icons_1.PercentOutlined,
    [core_1.FieldType.SingleText]: icons_1.TextOutlined,
    [core_1.FieldType.AutoNumber]: icons_1.AutonumberOutlined,
    [core_1.FieldType.CreatedTime]: icons_1.TimeFilled,
    [core_1.FieldType.LastModifiedTime]: icons_1.HistoryFilled,
    [core_1.FieldType.CreatedBy]: icons_1.UserAddOutlined,
    [core_1.FieldType.LastModifiedBy]: icons_1.UserEditOutlined,
    [core_1.FieldType.Cascader]: icons_1.CascadeOutlined,
};
const transformOptions = (fields, theme) => {
    const notSupportField = [core_1.FieldType.CreatedBy, core_1.FieldType.LastModifiedBy, core_1.FieldType.Member];
    return fields.filter(field => {
        if (field.type === core_1.FieldType.LookUp) {
            const entityField = core_1.Field.bindModel(field).getLookUpEntityField();
            return entityField ? !notSupportField.includes(entityField.type) : true;
        }
        return !notSupportField.includes(field.type);
    }).map(field => {
        const res = {
            label: field.name,
            value: field.id,
        };
        const FieldIcon = FieldIconMap[field.type];
        return Object.assign(Object.assign({}, res), { disabled: field.type === core_1.FieldType.DeniedField, prefixIcon: react_1.default.createElement(FieldIcon, { color: theme.palette.text.third }) });
    });
};
const FieldSelect = ({ fields, value, onChange }) => {
    const theme = (0, components_1.useTheme)();
    const options = transformOptions(fields, theme);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Select, { placeholder: (0, core_1.t)(core_1.Strings.pick_one_option), searchPlaceholder: (0, core_1.t)(core_1.Strings.search), options: options, value: value, onSelected: (option) => {
                onChange && onChange(option.value);
            }, hideSelectedOption: !value, dropdownMatchSelectWidth: true, openSearch: options.length > 7 }));
};
exports.FieldSelect = FieldSelect;
